// extracted by mini-css-extract-plugin
export default {"cls1":"_d2YDzNumeaJWns_2F9r","cls2":"y_6x5Ye91zVm_wmNcWtn _d2YDzNumeaJWns_2F9r"};